module.exports = __webpack_public_path__ + "static/media/error.098b0a9c.svg";